import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DataListModule } from "@bfx/primeng/datalist";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DialogModule } from "@bfx/primeng/dialog";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MenuModule } from "@bfx/primeng/menu";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";

import { BfxApplicationNotificationService } from "./services/bfx-application-notification.service";
import { BfxApplicationNotificationComponent } from "./bfx-application-notification.component";
import { BfxNotificationsBarComponent } from "./bfx-notifications-bar.component";
import { BfxNotificationViewerComponent } from "./bfx-notification-viewer.component";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { ButtonModule } from "@bfx/primeng/button";
import { TableModule } from "@bfx/primeng/table";
import { BfxApplicationSettingProviderService } from "app/bfx-notification-application/services/bfx-application-setting-provider.service";

@NgModule({
  providers: [BfxApplicationNotificationService, BfxApplicationSettingProviderService],
  declarations: [
    BfxNotificationsBarComponent,
    BfxNotificationViewerComponent,
    BfxApplicationNotificationComponent,
  ],
  exports: [
    // BfxPopupNotificationContainerComponent,
    BfxApplicationNotificationComponent,
    BfxNotificationViewerComponent,
    BfxNotificationsBarComponent,
  ],
  imports: [
    DialogModule,
    CommonModule,
    FlexLayoutModule,
    MenuModule,
    DataTableModule,
    OverlayPanelModule,
    DataListModule,
    NativeDesktopModule,
    BaseComponentsModule,
    ButtonModule,
    TableModule,
  ],
})
export class BfxApplicationNotificationModule {}
